import React, { useState, useEffect } from "react";
import { getAuth, signOut, updateProfile } from "firebase/auth";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import errorMessage from "../components/errorMessage";
import { auth, authWithoutApp } from "../firebase-config";
import { signOutRequest } from "../store/Actions/authAction";
import { AdminUserFeedback } from "../stories/AdminUserFeedback/AdminUserFeedback";
import { UnsortedStep } from "../stories/UnsortedStep1/UnsortedStep";
import { InputWithButton } from "../stories/InputWithButton/InputWithButton";
import { MobileFooter } from "../stories/MobileFooter/MobileFooter";
import { MobilePartnershipProgramCard } from "../stories/MobilePartnershipProgramCard/MobilePartnershipProgramCard";
import { PartnershipProgramCard } from "../stories/PartnershipProgramCard/PartnershipProgramCard";
import { MobileHeader } from "../stories/MobileHeader/MobileHeader";
import { DropDown } from "../stories/DropDown/DropDown";
import { Radio } from "../stories/Radio/Radio";
import { Tabs } from "../stories/Tabs/Tabs";
import { LinkButtonWithIcon } from "../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { TextArea } from "../stories/TextArea/TextArea";
import { HelpSearch } from "../stories/HelpSearch/HelpSearch";
import { MapPin } from "../stories/MapPin/MapPin";

import { CheckBoxAndRadioWithSearch } from "../stories/CheckBoxAndRadioWithSearch/CheckBoxAndRadioWithSearch.jsx";
import { Reviews } from "../stories/Reviews/Reviews";
import { AfterLoginHeader } from "../stories/AfterLoginHeader/AfterLoginHeader";
import { NameAvatar } from "../stories/NameAvatar/NameAvatar";
import { Input } from "../stories/Input/Input";
import { Switch } from "../stories/Switch/Switch";
import { CoachAvailablityCard } from "../stories/CoachAvailablityCard/CoachAvailablityCard";
import { CoachDetailCard } from "../stories/CoachDetailCard/CoachDetailCard";
import { DashboardSidebarWithCalendar } from "../stories/DashboardSidebarWithCalendar/DashboardSidebarWithCalendar";
import { InputWithSearchIcon } from "../stories/InputWithSearchIcon/InputWithSearchIcon";
import MobileBottomTab from "../stories/MobileBottomTab/MobileBottomTab";
import TodoMobile from "../components/CoachFlow/CoachDashboard/Todo/TodoMobile/TodoMobile";
import { CoachDetailAboutMe } from "../stories/CoachDetailAboutMe/CoachDetailAboutMe";
import { Footer } from "../stories/Footer/Footer";
import Partnership from "./GeneralScreens/Partnership/Partnership";
import { ReviewBox } from "../stories/ReviewBox/ReviewBox";
import { SideBarMenu } from "../stories/SideBarMenu/SideBarMenu";
import { BeforeLoginHeader } from "../stories/BeforeLoginHeader/BeforeLoginHeader";
import { CoachAccountInfoSidebar } from "../stories/CoachAccountInfoSidebar/CoachAccountInfoSidebar";
import ContactUsMobile from "./GeneralScreens/ContactUs/ContactUsMobile";
import HelpMobile from "./GeneralScreens/Help/HelpMobile";
import {
  FlagIconBlack,
  logoColor,
  AthleteImg,
  // SixToNineAmBlue,
  TestNewSVG,
  ArrowUpRightBlue,
  RangeSliderIcon,
  BackwardArrow,
  coachDemoImg,
  FilterIconBlack,
  ChatIconDisabled,
  messageIconBlack,
  CancelIconBlack,
} from "../constant/imagePath";
import { CoachDetailsCertificates } from "../stories/CoachDetailCertificates/CoachDetailsCertificates";
import { CoachInsightsSidebar } from "../stories/CoachInsightsSidebar/CoachInsightsSidebar";
import { ConfirmBookingLessonCard } from "../stories/ConfirmBookingLessonCard/ConfirmBookingLessonCard";
// import {CheckBoxAndRad}
import { NotificationBox } from "../stories/NotificationBox/NotificationBox";
import { TimeOfTheDay } from "../stories/TimeOfTheDay/TimeOfTheDay";
import { DoubleCalander } from "../stories/DoubleCalander/DoubleCalander";
import { AveragePriceRangePicker } from "../stories/AveragePriceRangePicker/AveragePriceRangePicker";
import { PriceInput } from "../stories/PriceInput/PriceInput";
import { DistanceRangePicker } from "../stories/DistanceRangePicker/DistanceRangePicker";
import { DashboardBookingDetailCard } from "../stories/DashboardBookingDetailCard/DashboardBookingDetailCard";
import { MyLessonCard } from "../stories/MyLessonCard/MyLessonCard";
import { SearchBar } from "../stories/SearchBar/SearchBar";
import { PerformanceEvaluationCard } from "../stories/PerformanceEvaluationCard/PerformanceEvaluationCard";
import { CommonQuestions } from "../stories/CommonQuestions/CommonQuestions";
import { WhatOurStudentSay } from "../stories/WhatOurStudentSay/WhatOurStudentSay";
import { ReactSVG } from "react-svg";
import { PlayCard } from "../stories/PlayCard/PlayCard";
import { Button } from "../stories/Button/Button";

import {
  ChakraProvider,
  RangeSlider,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  RangeSliderTrack,
} from "@chakra-ui/react";
import Colors from "../stories/assets/Colors";
import ReactSelect from "react-select";
import Tooltip from "../stories/Tooltip/index";
import CoachDetailsScheduleCard from "../stories/CoachDetailsScheduleCard/CoachDetailsScheduleCard";
import LessonCard from "../components/PopUps/Schedule/LessonCard";
import WeeklyAvailability from "../components/PopUps/Schedule/WeeklyAvailability";
import SingleCalendar from "../components/PopUps/Schedule/SingleCalendar";
import FilterModal from "../components/Modals/CoachFlow/Schedule/Filter/FilterModal";
import ScheduleLessonDetails from "../components/Modals/CoachFlow/Schedule/LessonDetails/LesssonDetails";
import MessageLessonDetails from "../components/Modals/CoachFlow/Messages/LessonDetails/LessonDetail";
import AddPayoutMethod from "../components/Modals/CoachFlow/OnBoarding/AddPayoutMethod/AddPayoutMethod";
import CoachAvailibility from "../components/Modals/StudentFlow/CoachDetails/CoachAvailibility/CoachAvailibility";
import SearchResultsPopup from "../components/PopUps/Map/SearchResults";

const Demo = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  // const [value, setValue] = useState(false);
  const [value, setValue] = useState([]);
  const [value1, setValue1] = useState(0);

  const [days, setDays] = useState([]);
  const [timings, setTimings] = useState([]);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      await dispatch(signOutRequest());
      history.pushState("/welcome");
    } catch (error) {
      const showErrorMessage = await errorMessage(error);
      toast.error(showErrorMessage);
    }
  };
  const [selectedState, setSelectedState] = useState([]);
  const [selectedRadioState, setSelectedRadioState] = useState("abc");
  const CheckboxArray = ["red", "green", "blue"];
  const [isOpenFilter, setIsOpenFilter] = useState(false);

  const [modal, showModal] = useState(true);

  return (
    <div style={{ marginTop: "0px" }}>
      {/* <p>
        {auth?.currentUser?.email == undefined
          ? "error"
          : auth?.currentUser?.email}
      </p>
      <p
        onClick={() => {
          handleSignOut();
        }}
      >
        logout
      </p>
      <p
        onClick={() => {
          history.push("/demo");
        }}
      >
        move to demo
      </p>
      <p
        onClick={() => {
          history.push("/Dashboard");
        }}
      >
        move to dashboard
      </p> */}

      {/* <AdminUserFeedback /> */}
      {/* <AfterLoginHeader /> */}
      {/* <AveragePriceRangePicker
        minAndMaxPrice={value}
        setMinAndMaxPrice={setValue}
      />
      <DistanceRangePicker value={value1} setValue={setValue1} /> */}
      {/* <BeforeLoginHeader/> */}
      {/* <Button label={"abc"} icon={flagIcon} /> */}
      {/* <CheckBoxAndRadioWithSearch isSearch type="radio" /> */}
      {/* <CoachAccountInfoSidebar /> */}
      {/* <CoachDetailsCertificates /> */}
      {/* No Issue */}
      {/* <CoachAvailablityCard /> */}

      {/* Today */}
      {/* <CheckboxAndRadioMenu /> */}
      {/* <CoachDetailAboutMe /> */}
      {/* <CoachInsightsSidebar /> */}
      {/* <ConfirmBookingLessonCard disabled={true} /> */}
      {/* <LinkButtonWithIcon  /> */}
      {/* <CoachAccountInfoSidebar /> */}
      {/* <DistanceRangePicker value={value} setValue={setValue} /> */}
      {/* <MobileFooter /> */}
      {/* <MyLessonCard type={"completed"} /> */}
      {/* <NotificationBox /> */}
      {/* <PerformanceEvaluationCard /> */}
      {/* <PriceInput state={value} setter={setValue} /> */}
      {/* <SideBarMenu /> */}
      {/* <Tabs state={value} setState={setValue} /> */}
      {/* <TimeOfTheDay /> */}
      {/* <DistanceRangePicker /> */}
      {/* <CheckBoxAndRadioMenu /> */}
      {/* <DoubleCalander /> */}
      {/* <CoachDetailCard /> */}
      {/* <DashboardBookingDetailCard /> */}

      {/* Today */}
      {/* <TimeOfTheDay /> */}
      {/* <MobilePartnershipProgramCard
        image={AthleteImg}
        heading={"Athlete Test"}
        description={"All of our coaches have extensive coaching experience and are required to pass rigorous background checks."}

      /> */}
      {/* <PartnershipProgramCard
        image={AthleteImg}
        heading={"Athlete Test"}
        description={
          "All of our coaches have extensive coaching experience and are required to pass rigorous background checks."
        }
        onClick={() => {
          setActivePartnershipProgramCardIndex(index);
        }}
        isActive={true}
      /> */}

      {/* <TimeOfTheDay
        selectedDays={days}
        setSelectedDays={setDays}
        selectedTimings={timings}
        setSelectedTimings={setTimings}
      /> */}
      {/* <MobileFooter /> */}
      {/* <UnsortedStep /> */}

      {/* <div style={{
  width: "100%",
  display: "flex",
  justifyContent: "space-evenly",
  alignItems: "center",
}}>

<DistanceRangePicker value={value1} setValue={setValue1} />
<AveragePriceRangePicker minAndMaxPrice={value} setMinAndMaxPrice={setValue} />

</div> */}
      {/* <HelpSearch /> */}
      {/* <MyLessonCard type={"rejected"} /> */}
      {/* <UnsortedStep />
      <PerformanceEvaluationCard />
      <ReviewBox />
      <SearchBar ShowShadow={false} /> */}
      {/* <SideBarMenu /> */}
      <div
        className="col-md-12"
        style={{
          maxWidth: "50%",
          // backgroundColor: "lightblue",
        }}
      >
        {/* <WhatOurStudentSay />
        <CommonQuestions />
        <Footer />
        <MobileFooter/>
        <CoachDetailAboutMe /> */}
        {/* <ConfirmBookingLessonCard /> */}
        {/* <MobileHeader /> */}
        {/* <CoachAvailablityCard /> */}
        {/* <ConfirmBookingLessonCard /> */}

        {/* Today */}
        {/* <MobileBottomTab state={value} setter={setValue} /> */}
      </div>
      {/* <BeforeLoginHeader icon={logoColor} /> */}
      {/* <LinkButtonWithIcon
        text={"abc"}
        rightIcon={ArrowUpRightBlue}
        primary={true}
      /> */}
      {/* <ReviewBox /> */}
      {/* <SideBarMenu /> */}
      {/* <MyLessonCard /> */}
      {/* <MobilePartnershipProgramCard /> */}
      {/* <MobileHeader isLogo={true} isAvatar={true} /> */}
      {/* <PartnershipProgramCard /> */}
      {/* <ConfirmBookingLessonCard /> */}
      {/* <DashboardBookingDetailCard /> */}
      {/* <Button icon={FlagIconBlack} /> */}
      {/* <PerformanceEvaluationCard /> */}
      {/* <CoachAccountInfoSidebar /> */}
      {/* <AfterLoginHeader /> */}
      {/* <PlayCard /> */}
      {/* <ReviewBox /> */}
      {/* <CoachDetailAboutMe /> */}
      {/* <CoachDetailsCertificates /> */}
      {/* <Button label={"ABbnasd"} primary={false} /> */}
      {/* <Button icon={BackwardArrow} /> */}
      {/* <DashboardBookingDetailCard /> */}
      {/* <MyLessonCard /> */}
      {/* <ImageBoxWithDeleteBtn item={coachDemoImg} /> */}
      {/* <MobileHeader isLogo={true} /> */}

      {/* <ReviewBox /> */}
      {/* <NotificationBox isSeen={false} type="complete" /> */}
      <div style={{ width: "200px" }}>
        {/* <InputWithButton /> */}
        {/* <DropDown
          options={[
            { label: "abc", value: "abc" },
            { label: "abc1", value: "abc1" },
            { label: "abc2", value: "abc2" },
          ]}
          state={value}
          setter={setValue}
        /> */}
        {/* <InputWithSearchIcon state={value} setter={setValue} /> */}
        {/* <Button
          icon={messageIconBlack}
          disabledIcon={ChatIconDisabled}
          disabled={true}
        /> */}
        {/* <ReviewBox /> */}
      </div>
      {/* <ConfirmBookingLessonCard /> */}
      {/* <MyLessonCard /> */}
      {/* <CoachDetailCard /> */}
      {/* <CoachAccountInfoSidebar /> */}
      {/* <CoachAvailablityCard /> */}
      {/* <DashboardBookingDetailCard disabled={true} /> */}
      {/* <ConfirmBookingLessonCard /> */}
      {/* <DashboardBookingDetailCard /> */}
      {/* <MobilePartnershipProgramCard /> */}
      {/* <PerformanceEvaluationCard /> */}
      {/* <ReviewBox /> */}
      {/* <DistanceRangePicker value={value} setValue={setValue} /> */}

      {/* <DashboardBookingDetailCard /> */}
      {/* <DistanceRangePicker value={value} setValue={setValue} /> */}
      {/* <CustomToolTip tooltip={"ABABs"}>
        <Button
          customStyle={{
            marginRight: "20px",
            padding: "12px",
          }}
          icon={CancelIconBlack}
        />
      </CustomToolTip>
      <CustomToolTip tooltip={"normal"}>
        <button style={{ margin: "20px" }}>normal button</button>
      </CustomToolTip>
      <CustomToolTip tooltip={"normal"}>
        <p style={{ margin: "20px" }}>para</p>
      </CustomToolTip> */}
      {/* <CoachDetailsScheduleCard /> */}
      {/* <CoachAvailablityCard /> */}
      {/* <LessonCard /> */}
      {/* <WeeklyAvailability /> */}
      {/* <CoachDetailsScheduleCard /> */}
      {/* <CoachAvailablityCard /> */}
      {/* <MonthSmallCalander /> */}

      {/* <FilterModal show={true} setShow={setIsOpenFilter} /> */}
      {/* <LessonAccepted show={true} /> */}
      {/* <CancelLesson show={true} /> */}
      {/* <CancelBooking show={true} /> */}
      {/* <MessageLessonDetails show={true} /> */}
      {/* <AddPayoutMethod show={modal} setShow={showModal} /> */}
      {/* <CoachAvailibility show={modal} setShow={showModal} /> */}
    </div>
  );
};

export default Demo;
